import { DefaultButton, FontIcon, IProcessedStyleSet } from "office-ui-fabric-react";
import React from "react";
import { DiagnosticsActionStatus, IComponentStyleProps, IRuntimeHandlerConfig, IDiagnosticsStatusBarStyles } from "../..";
import { GraphNode, Meta, ParamOrVar } from "../../models";
import { IImmutableList, IImmutableMap } from "../../state/redux";
import { uuidOptions } from "../../utils";
import { getOptionBtnStyles } from "../intentGraph.styles";
import { TextFieldComponent } from "./textFieldComponent";

interface IDiagnosticStatusBarProps {
    classNames: IProcessedStyleSet<Partial<IDiagnosticsStatusBarStyles>>;
    node: IImmutableMap<GraphNode>;
    prefix: string;
    callbackHandlers: Partial<IRuntimeHandlerConfig>;
    sessionId: string;
    meta: IImmutableMap<Meta>;
    globalVars: IImmutableList<IImmutableMap<ParamOrVar>>
    dialogId: string;
}

type IStatusBarProps = IComponentStyleProps & IDiagnosticStatusBarProps;

const uuidv4 = require('uuid/v4');

export const DiagnosticStatusBar = (props: IStatusBarProps) => {
    const title = props.node.get('title');
    const nodeId = props.node.get('id');
    const content = title && title.get('content') ? title.get('content') : '';
    const key = uuidv4(uuidOptions());
    const status = props.node.get('diagnosticsActionStatus');
    const statusIsCompleted = status === DiagnosticsActionStatus.CompletedSuccessfully;
    const prefix =  props.prefix;
    const showSafStatusBar =
      status === DiagnosticsActionStatus.CompletedSuccessfully || status === DiagnosticsActionStatus.Error;
    return (
      showSafStatusBar && (
        <div key={key + `-${prefix}header`} aria-live="assertive" aria-atomic="false">
          <DefaultButton
            role="mark"
            key={key}
            tabIndex={-1}
            styles={getOptionBtnStyles({ theme: props.theme, stylesFunc: props.stylesFunc })}
            checked={true}
            primary={true}
          >
            <TextFieldComponent
              componentkey={`${nodeId}$title$${key}`}
              key={`${key}$title$`}
              callbackHandlers={props.callbackHandlers}
              stylesFunc={props.stylesFunc}
              textContent={props.node.get('title')}
              className={props.classNames.label}
              sessionId={props.sessionId}
              node={props.node}
              meta={props.meta}
              globalVars={props.globalVars}
              dialogId={props.dialogId}
              />
            <FontIcon
              iconName={statusIsCompleted ? 'CompletedSolid' : 'StatusErrorFull'}
              className={statusIsCompleted ? props.classNames.completedIcon : props.classNames.failedIcon}
              key={`${props.node.get('id')}$${prefix}Icon$nodeAccordion`}
            />
          </DefaultButton>
        </div>
      )
    );
  };